import { useSyncExternalStore } from "react";

/** Where the app opens on launch, kept per device like the theme. */
export type LaunchSetting = "last" | "library";

const KEY = "quill.openOnLaunch";
const listeners = new Set<() => void>();

function read(): LaunchSetting {
  try {
    return localStorage.getItem(KEY) === "library" ? "library" : "last";
  } catch {
    return "last";
  }
}

let setting = read();

export const launchSetting = () => setting;

export function setLaunchSetting(next: LaunchSetting) {
  setting = next;
  try {
    if (next === "last") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, next);
  } catch {
    // ignore
  }
  listeners.forEach((l) => l());
}

export function useLaunchSetting(): LaunchSetting {
  return useSyncExternalStore(
    (fn) => {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
    () => setting,
  );
}
